import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const SETTLEMENT = {
  YES: 'yes',
  NO: 'no',
} as const;

export const SETTLEMENT_NAME = 'settlement';

interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const RadioGroupSettlement: FC<Props> = ({ name = SETTLEMENT_NAME }) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{i18n.t('Czy była zawierana ugoda?')}</FormLabel>
          <FormControl>
            <RadioGroup {...field} layout={'horizontal'}>
              <RadioItem
                data-testid={`${name}-radio-group-${SETTLEMENT.NO}`}
                value={SETTLEMENT.NO}
                label={i18n.t('Nie')}
              />
              <RadioItem
                data-testid={`${name}-radio-group-${SETTLEMENT.YES}`}
                value={SETTLEMENT.YES}
                label={i18n.t('Tak')}
              />
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
